import React, { useContext, useState, useEffect } from "react";
import TopBar from "../../components/TopBar/Navbar";
import { Layout, Button, message } from "antd";
import "../UserManager/UserManager.css";
import UserList from "./UserList";
import UserForm from "./UserForm";
import AddUserForm from "./AddUserForm";
import listApi from "../../services/api";
import { AuthContext } from "../../context/AuthContext";

const { Content } = Layout;

export const UserManager = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [users, setUsers] = useState([]);
  const { userData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userData?.session_id) {
      listUser();
    }
  }, [userData]); // Chỉ gọi lại khi `userData` thay đổi

  async function listUser() {
    setLoading(true);
    try {
      const response = await fetch(listApi.listUser, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: userData?.session_id }),
      });

      const data = await response.json();
      if (data.code === 200) {
        setUsers(data.list_user);
      } else {
        message.error("Lỗi tải danh sách: " + data.message);
      }
    } catch (error) {
      message.error("Lỗi kết nối API!");
      console.error("Lỗi khi lấy danh sách người dùng:", error);
    } finally {
      setLoading(false);
    }
  }
  async function handleAddUser(newUser) {
    setLoading(true)
    try {
      const response = await fetch(listApi.createUser, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...newUser, session_id: userData?.session_id }),
      });
      const data = await response.json();
      if (data.code === 200) {
        message.success("Tạo người dùng thành công!");
        listUser(); // Refresh danh sách người dùng
        setIsModalVisible(false);
      } else {
        message.error(data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Lỗi khi thêm người dùng:", error);
    }
  }

  async function handleUpdateUser(updatedUser) {
    console.log("Check user update--------->", updatedUser);
    const user = updatedUser.values
    setLoading(true)
    try {
      const response = await fetch(listApi.updateUser, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
        	fullname:user.full_name,
          email:user.email,
          type: user.type_name,
          user_id: user.id,
          session_id: userData?.session_id
        }),
      });
      const data = await response.json();
      if (data.code === 200) {
        message.success("Cập nhật thành công!");
        listUser(); // Refresh danh sách người dùng
        setSelectedUser(null);
      } else {
        message.error("Lỗi cập nhật người dùng",data.message);
        setLoading(false);
      }
    } catch (error) {
      console.error("Lỗi khi cập nhật người dùng:", error);
      setLoading(false);
    }
  }

  async function handleDeleteUser(userId) {
    console.log("Check id---->",userId )
    try {
      const response = await fetch(listApi.deleteUser, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
            user_id: userId, 
            session_id: userData?.session_id
        }),
      });
      const data = await response.json();
      if (data.code === 200) {
        message.success("Xóa thành công!");
        listUser();
        setUsers(users.filter((user) => user.id !== userId));
        setSelectedUser(null);
      } else {
        setLoading(false);
        message.error(data.desc);
      }
    } catch (error) {
      setLoading(false);
      console.error("Lỗi khi xóa người dùng:", error);
    }
  }

  return (
    <>
          <Content>
            <div style={{display:'flex', justifyContent: 'flex-end', marginBottom:10, maxWidth:'100%'}}> 
              <Button type="primary" onClick={() => setIsModalVisible(true)}>
                + Thêm người dùng
              </Button>
            </div>
            {   <UserList selectedUser={selectedUser} users={users} onSelectUser={setSelectedUser} />}

            {selectedUser && (
              <UserForm user={selectedUser} onUpdate={handleUpdateUser} onDelete={handleDeleteUser} />
            )}
            <AddUserForm visible={isModalVisible} onCancel={() => setIsModalVisible(false)} onSave={handleAddUser} />
          </Content>

    </>
  );
};

export default UserManager;
